import React from "react";
import { Table, Button } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "antd/dist/reset.css";

const SeminarsWorkshops = () => {
  const navigate = useNavigate();

  const handleRegisterClick = (seminarId) => {
    // Navigate to seminar detail page with the seminar ID
    navigate(`/seminar-detail`);
  };

  // 🔹 Seminars table columns
  const seminarColumns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      responsive: ["xs", "sm", "md", "lg"],
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      responsive: ["sm", "md", "lg"],
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      responsive: ["md", "lg"],
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      responsive: ["md", "lg"],
    },
    {
      title: "Registrations",
      dataIndex: "registrations",
      key: "registrations",
      responsive: ["xs", "sm", "md", "lg"],
      render: (text, record) => (
        <Button 
          type="link" 
          style={{ color: "#722ed1", padding: 0 }}
          onClick={() => handleRegisterClick(record.key)}
        >
          {text} <RightOutlined style={{ fontSize: "10px" }} />
        </Button>
      ),
    },
  ];

  // 🔹 Workshops table columns
  const workshopColumns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      responsive: ["xs", "sm", "md", "lg"],
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      responsive: ["sm", "md", "lg"],
    },
    {
      title: "Time / Duration",
      dataIndex: "timeDuration",
      key: "timeDuration",
      responsive: ["md", "lg"],
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      responsive: ["md", "lg"],
    },
    {
      title: "Registrations",
      dataIndex: "registrations",
      key: "registrations",
      responsive: ["xs", "sm", "md", "lg"],
      render: (text, record) => (
        <Button 
          type="link" 
          style={{ color: "#722ed1", padding: 0 }}
          onClick={() => handleRegisterClick(record.key)}
        >
          {text} <RightOutlined style={{ fontSize: "10px" }} />
        </Button>
      ),
    },
  ];

  // 🔹 Seminars data
  const seminarData = [
    {
      key: "seminar-1",
      title: "Youth Sports & Nutrition Seminar",
      date: "9 Nov 2025",
      time: "2:00 PM - 4:00 PM",
      location: "Dubai Stadium",
      registrations: "Register",
    },
    {
      key: "seminar-2",
      title: "Mental Strength in Sports",
      date: "15 Dec 2025",
      time: "10:00 AM - 12:00 PM",
      location: "Yalla Nellab Sports Hall",
      registrations: "Register",
    },
    {
      key: "seminar-3",
      title: "Injury Prevention & Recovery",
      date: "10 Jan 2026",
      time: "1:00 PM - 3:30 PM",
      location: "Elite Fitness Center, Dubai",
      registrations: "Register",
    },
  ];

  // 🔹 Workshops data
  const workshopData = [
    {
      key: "workshop-1",
      title: "Football Moves Workshop",
      date: "9 Nov 2025",
      timeDuration: "2:00 PM - 4:00 PM\n4 days",
      location: "Dubai Stadium",
      registrations: "Register",
    },
    {
      key: "workshop-2",
      title: "Basketball Skills Masterclass",
      date: "12 Dec 2025",
      timeDuration: "5:00 PM - 7:00 PM\n3 days",
      location: "Yalla Arena Court",
      registrations: "Register",
    },
    {
      key: "workshop-3",
      title: "Swimming for Beginners",
      date: "5 Jan 2026",
      timeDuration: "3:00 PM - 5:00 PM\n5 days",
      location: "Aqua Club, Dubai Marina",
      registrations: "Register",
    },
  ];

  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "1200px",
        margin: "0 auto",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
      }}
    >
      {/* 🔹 Header Section */}
      <div style={{ marginBottom: "40px", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "clamp(24px, 5vw, 32px)",
            fontWeight: "600",
            marginBottom: "8px",
            color: "#000",
          }}
        >
          Seminars & Workshops
        </h1>
        <p
          style={{
            fontSize: "clamp(14px, 3vw, 16px)",
            color: "#666",
            margin: 0,
          }}
        >
          Learn, share, and grow with experts through interactive sports
          sessions that inspire skills and teamwork.
        </p>
      </div>

      {/* 🔹 Upcoming Seminars Section */}
      <div style={{ marginBottom: "40px" }}>
        <h2
          style={{
            fontSize: "clamp(18px, 4vw, 20px)",
            fontWeight: "600",
            marginBottom: "16px",
            color: "#000",
          }}
        >
          Upcoming Seminars
        </h2>
        <Table
          columns={seminarColumns}
          dataSource={seminarData}
          pagination={false}
          scroll={{ x: "max-content" }}
          style={{
            backgroundColor: "#fff",
          }}
          rowClassName={(_, index) =>
            index % 2 === 0 ? "row-purple" : "row-white"
          }
        />
      </div>

      {/* 🔹 Upcoming Workshops Section */}
      <div>
        <h2
          style={{
            fontSize: "clamp(18px, 4vw, 20px)",
            fontWeight: "600",
            marginBottom: "16px",
            color: "#000",
          }}
        >
          Upcoming Workshops
        </h2>
        <Table
          columns={workshopColumns}
          dataSource={workshopData}
          pagination={false}
          scroll={{ x: "max-content" }}
          style={{
            backgroundColor: "#fff",
          }}
          rowClassName={(_, index) =>
            index % 2 === 0 ? "row-purple" : "row-white"
          }
        />
      </div>

      {/* 🔹 Table Styling */}
      <style jsx>{`
        .row-purple {
          background-color: #f3e5f5 !important;
        }
        .row-white {
          background-color: #ffffff !important;
        }
        .ant-table-thead > tr > th {
          background-color: #fff !important;
          font-weight: 600;
          border-bottom: 2px solid #f0f0f0;
          color: #000;
          padding: 12px 16px;
        }
        .ant-table-tbody > tr > td {
          padding: 16px;
          border-bottom: 1px solid #f0f0f0;
        }
        .ant-table {
          border: 1px solid #f0f0f0;
          border-radius: 4px;
        }
        /* Remove hover effect completely */
        .ant-table-tbody > tr:hover > td {
          background: inherit !important;
        }
        @media (max-width: 768px) {
          .ant-table-tbody > tr > td {
            padding: 12px 8px;
            font-size: 14px;
          }
          .ant-table-thead > tr > th {
            padding: 10px 8px;
            font-size: 14px;
          }
        }
      `}</style>
    </div>
  );
};

export default SeminarsWorkshops;